import { RotateCcw, Search } from 'lucide-react';
import { useReconciliationFilters } from '../store/filters.store';

const KINDS = [
  { value: '', label: 'All Kinds' },
  { value: 'STUCK_PAYMENT', label: 'Stuck Payment' },
  { value: 'DOUBLE_CAPTURE', label: 'Double Capture' },
  { value: 'DUPLICATE_CAPTURE', label: 'Duplicate Capture' },
  { value: 'AMOUNT_DRIFT', label: 'Amount Drift' },
  { value: 'STUCK_REFUND', label: 'Stuck Refund' },
  { value: 'ORPHANED_REFUND_REQUEST', label: 'Orphan Refund Request' },
  { value: 'ORPHAN_GATEWAY_PAYMENT', label: 'Orphan Gateway Payment' },
  { value: 'OUT_OF_BAND_REFUND', label: 'Refund Made Outside App' },
  { value: 'SETTLEMENT_FEE_MISMATCH', label: 'Fee Mismatch' },
  { value: 'DISPUTED_PAYMENT', label: 'Dispute / Chargeback' },
];

const ENTITY_TYPES = [
  { value: '', label: 'All Entity Types' },
  { value: 'Invoice', label: 'Invoice' },
  { value: 'Refund', label: 'Refund' },
  { value: 'BillingPayment', label: 'Billing Payment' },
  { value: 'Settlement', label: 'Settlement' },
];

export function FindingFilters() {
  const { kind, entityType, searchQuery, setFilter, reset } = useReconciliationFilters();

  const hasActiveFilters = Boolean(kind || entityType || searchQuery);

  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      {/* Search Input */}
      <div className="relative flex-1">
        <Search className="w-4 h-4 text-on-surface-variant absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none" />
        <input
          data-testid="search-findings-input"
          type="text"
          value={searchQuery}
          onChange={(e) => setFilter('searchQuery', e.target.value)}
          placeholder="Search by entity ID, correlation ID..."
          className="w-full pl-10 pr-4 py-2 bg-surface-container/60 border border-border-subtle rounded-xl text-sm text-on-surface placeholder:text-on-surface-variant focus:outline-none focus:border-primary transition-all font-mono"
        />
      </div>

      {/* Kind Dropdown */}
      <div className="w-full sm:w-48">
        <select
          data-testid="filter-kind"
          value={kind ?? ''}
          onChange={(e) => setFilter('kind', e.target.value || undefined)}
          className="w-full px-3 py-2 bg-surface-container/60 border border-border-subtle rounded-xl text-sm text-on-surface focus:outline-none focus:border-primary transition-all"
        >
          {KINDS.map((k) => (
            <option key={k.value} value={k.value}>
              {k.label}
            </option>
          ))}
        </select>
      </div>

      {/* Entity Type Dropdown */}
      <div className="w-full sm:w-44">
        <select
          data-testid="filter-entity-type"
          value={entityType ?? ''}
          onChange={(e) => setFilter('entityType', e.target.value || undefined)}
          className="w-full px-3 py-2 bg-surface-container/60 border border-border-subtle rounded-xl text-sm text-on-surface focus:outline-none focus:border-primary transition-all"
        >
          {ENTITY_TYPES.map((et) => (
            <option key={et.value} value={et.value}>
              {et.label}
            </option>
          ))}
        </select>
      </div>

      {/* Reset button */}
      {hasActiveFilters && (
        <button
          type="button"
          onClick={reset}
          className="inline-flex items-center gap-1.5 px-3 py-2 rounded-xl border border-border-subtle text-xs font-medium text-on-surface-variant hover:text-on-surface hover:bg-white/5 transition-all shrink-0"
        >
          <RotateCcw className="w-3.5 h-3.5" />
          Reset
        </button>
      )}
    </div>
  );
}
